import { render, staticRenderFns } from "./IntegrationRow.vue?vue&type=template&id=5878d80b&"
import script from "./IntegrationRow.vue?vue&type=script&lang=js&"
export * from "./IntegrationRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports